// extracted by mini-css-extract-plugin
export default {"cardWrapper":"index_cardWrapper__q-d9T","deleteBtn":"index_deleteBtn__eGRrk","selectedCheckbox":"index_selectedCheckbox__omPvF"};